export const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]+$/

/**
 * Returns non-alphabetical characters. Useful for sanitizing strings.
 * @example 'GA/$' // matches '/$'
 */
export const NON_ALPHA_REGEX = /[^A-Za-z0-9]/g
